var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _rect2, _path12, _path13, _path14, _path15, _rect3, _ellipse, _path16, _path17, _g, _path18, _path19, _rect4, _path20, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 315,
    height: 223,
    viewBox: "0 0 315 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.7876,
    y: 210.657,
    width: 284.337,
    height: 9.4779,
    rx: 4.73895,
    fill: "#99A5A2",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M266.058 210.657L229.5 53.2562L232.208 31.2539L273.505 210.657H266.058Z",
    fill: "#99A5A2",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M209.868 210.657L173.31 53.2562L176.018 31.2539L217.315 210.657H209.868Z",
    fill: "#99A5A2",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.429 217.427H131.336C141.378 171.166 162.478 74.5138 166.54 57.9952C171.617 37.3469 175.679 27.1922 181.772 16.6988C187.865 6.20538 207.16 -4.28801 223.069 4.51289C235.796 11.5536 236.27 27.982 234.916 35.3161L193.281 217.427H185.834C199.826 156.723 227.943 34.436 228.485 30.9156C229.162 26.5152 227.131 12.2981 217.315 8.91314C207.498 5.52817 197.682 8.23614 187.527 19.068C179.403 27.7335 171.505 64.4265 168.571 81.6899L137.429 217.427Z",
    fill: "#899C9A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M163.832 82.0291L165.525 75.5977H217.653L215.622 82.0291H163.832Z",
    fill: "#BECDCA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M162.478 86.4297L163.832 82.0293H215.622L214.268 86.4297H162.478Z",
    fill: "#EDEDED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.385 117.57L158.078 111.139H210.206L208.175 117.57H156.385Z",
    fill: "#BECDCA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M155.031 121.971L156.385 117.57H208.175L206.821 121.971H155.031Z",
    fill: "#EDEDED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.261 150.744L149.954 144.312H202.082L200.051 150.744H148.261Z",
    fill: "#BECDCA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M146.907 155.145L148.261 150.744H200.051L198.697 155.145H146.907Z",
    fill: "#EDEDED"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M140.137 187.977L141.83 181.546H193.958L191.927 187.977H140.137Z",
    fill: "#BECDCA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M138.783 192.378L140.137 187.978H191.927L190.573 192.378H138.783Z",
    fill: "#EDEDED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.675 217.088H127.952C138.896 168.57 161.611 66.1056 166.54 45.809C171.719 24.4837 177.034 16.6987 179.403 13.9907C184.142 8.57483 198.02 -4.83224 218.669 1.80467C233.081 6.43701 232.886 28.2076 228.824 40.3929L187.866 217.088H183.465L214.607 85.7514C219.007 67.1341 226.116 36.3309 227.47 24.4837C226.454 15.3443 222.089 0.497422 199.374 5.52795C185.835 8.52654 174.326 28.5455 169.248 52.2404L131.675 217.088Z",
    fill: "#D9D9D9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M171.279 69.1658V79.6592H209.868C209.868 76.2743 210.815 68.9625 206.483 62.7341C201.405 56.6414 195.651 57.9954 186.173 57.9954C176.695 57.9954 172.407 65.4423 171.279 69.1658Z",
    fill: "#ECAE35"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 173.987,
    y: 65.7803,
    width: 4.06196,
    height: 9.4779,
    rx: 2.03098,
    fill: "#FCCC60"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M186.173 57.9951C181.569 59.6199 179.967 63.4111 179.741 65.1035H189.219C190.032 61.5832 194.297 58.8978 196.328 57.9951H186.173Z",
    fill: "#D08C23"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M192.266 76.951H171.279V83.0436H209.868V69.8422C209.868 66.0511 207.611 63.5238 206.483 62.7341C195.109 62.4633 192.266 72.0992 192.266 76.951Z",
    fill: "#D08C23"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M209.868 81.6896L195.651 79.9971V85.0745H209.868V81.6896Z",
    fill: "#D2972F"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M194.635 79.3203H171.279L164.509 82.7053V85.0748H194.635C196.554 85.1876 200.39 84.804 200.39 82.3668C200.39 79.9296 196.554 79.3203 194.635 79.3203Z",
    fill: "#EFB236"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 167.894,
    y: 82.0283,
    width: 26.4027,
    height: 1.35399,
    rx: 0.676993,
    fill: "#FECA5D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.3702,
    cy: 218.442,
    rx: 29.3702,
    ry: 3.72346,
    fill: "#D9D9D9",
    fillOpacity: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3444 149.39L10.1274 210.319H48.6125L31.7331 149.39H27.3444Z",
    fill: "#ED963D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10581_21017",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 149,
    width: 39,
    height: 61
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3444 149.051L10.1274 209.98H48.6125L31.7331 149.051H27.3444Z",
    fill: "#ED963D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10581_21017)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.5544,
    y: 162.252,
    width: 24.3064,
    height: 8.80091,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7771,
    y: 179.854,
    width: 41.8609,
    height: 16.2478,
    fill: "white"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8409 198.81L10.1274 210.319H48.6125L41.1856 182.9C41.1856 182.9 43.2111 199.825 31.0579 203.887C19.9175 207.611 13.8409 198.81 13.8409 198.81Z",
    fill: "#E68538",
    fillOpacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.72607 213.026L10.4651 210.318H48.2749L54.3515 213.026H4.72607Z",
    fill: "#DE6536"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 212.688,
    width: 58.7403,
    height: 5.41594,
    fill: "#EC963F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3262 215.058L58.7403 212.688V218.104H0L52.3262 215.058Z",
    fill: "#E48436"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 1.35062,
    height: 46.7199,
    rx: 0.675312,
    transform: "matrix(0.961666 0.274224 -0.272864 0.962053 28.3735 152.831)",
    fill: "white",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderConstruction);
export default __webpack_public_path__ + "static/media/underConstruction.a3b16b44b5a0d525d3c264352dba94e4.svg";
export { ForwardRef as ReactComponent };